import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Container, Grid, Card, CardMedia, CardContent,
    Typography, Box, Modal, Button,
} from '@mui/material';
import dummyImage from '../../assets/images/dummyImage.png';
import './course.scss';
import { getCoursesApi, fetchPaymentHistoryList } from '../../redux/action/user';
import CenterLoading from '../../component/core/CenterLoading';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { ImgPath } from '../../constants/ImgPath';
import { isSubscriptionActive } from '../../common';

const Courses = (props) => {
    const recipeData = {
        courseName: 'Eat to Heal & Thrive. Love Every Bite.',
        imageUrl: ImgPath.recipeImg,
        recipeUrl: props.user?.recipeUrl,
        description: 'You don’t have to choose between flavor and vitality. These anti-inflammatory recipes (with instructional videos) are simple, satisfying, and updated weekly, curated by Michelin-trained Chef Janene, who healed herself from lupus. Discover just how delicious and easy eating for energy, healing, and longevity can be!'
    }


    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const navigate = useNavigate();

    const [clickedItemType, setClickedItemType] = useState('');

    const isSubscription = isSubscriptionActive(props?.user)

    const getCourses = async () => {
        setLoading(true);
        try {
            const data = await getCoursesApi();
            setCourses(data?.data);
        } catch (error) {
            // console.error('Error fetching courses', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCourses();
    }, []);

    useEffect(() => {
        const userKey = localStorage.getItem('userKey');
        if (userKey) {
            props.fetchPaymentHistoryList();
        }
    }, []);

    const renderCourseCard = (course) => {
        const recipeUrl = Object.prototype.hasOwnProperty.call(course, 'recipeUrl');
        return (
            <Card sx={{ maxWidth: 345, mx: "auto", minHeight: '380px', position: 'relative' }}>
                {recipeUrl && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: "14px",
                            left: "-80px",
                            background: 'linear-gradient(135deg, #d32f2f, #b71c1c)',
                            color: 'white',
                            transform: 'rotate(-45deg)',
                            width: '220px',
                            height: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontWeight: 'bold',
                            fontSize: '13px',
                            zIndex: 10,
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                            fontFamily: 'Arial, sans-serif',
                            borderTop: '2px solid #fff',
                            borderBottom: '2px solid #fff',
                        }}
                    >
                        Recipes
                    </Box>
                )}
                <CardMedia
                    component="img"
                    height="200"
                    image={course?.imageUrl || dummyImage}
                    alt={course?.courseName || "No image"}
                />
                <CardContent sx={{ padding: '16px', textAlign: 'center' }}>
                    <Typography
                        sx={{
                            ...textClampStyles(1),
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            color: '#333',
                            textAlign: 'center'
                        }}
                    >
                        <span dangerouslySetInnerHTML={{ __html: course?.courseName || " " }} />
                    </Typography>
                    <Typography
                        sx={{
                            ...textClampStyles(5),
                            fontSize: '0.9rem',
                            color: '#555',
                            marginTop: '8px',
                        }}
                    >
                        <span dangerouslySetInnerHTML={{ __html: course?.description || " " }} />
                    </Typography>
                </CardContent>
            </Card>
        )
    };

    const handleCardClick = (item) => {
        if (props.user?.isLoading && localStorage.getItem('userKey')) {
            return;
        }

        const isCourse = !!item?.LmsLink;
        const isRecipe = !!item?.recipeUrl;
        const recipeUrl = Object.prototype.hasOwnProperty.call(item, 'recipeUrl');

        const hasValidLink = isSubscription && (isCourse || isRecipe);
        const link = item?.LmsLink || item?.recipeUrl;

        if (hasValidLink && link) {
            window.location.href = link;

        } else {
            setClickedItemType(recipeUrl ? 'recipe' : 'course');
            setOpenConfirmModal(true);
        }
    };


    return (
        <>
            {loading ? (
                <CenterLoading open={loading} />
            ) : (
                <Container sx={{ padding: "5px", background: "#f9f9f9", minHeight: "calc(100vh - 140px)" }} className='courseList'>
                    <Box display="flex" justifyContent="center" alignItems="center" my={3}>
                        {courses?.courses?.length > 0 ? (
                            <Grid container spacing={3} justifyContent="center">
                                {[...courses?.courses, recipeData]?.map((course, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <Box onClick={() => handleCardClick(course)} sx={{ cursor: 'pointer' }}>
                                            {renderCourseCard(course)}
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    color: '#777',
                                    padding: '20px',
                                }}
                            >
                                🚀 No Courses Available! Please check back later.
                            </Typography>
                        )}
                    </Box>
                </Container>
            )}

            <Modal open={openConfirmModal} onClose={() => setOpenConfirmModal(false)}>
                <Box sx={modalStyle} width={"fit-content"} maxWidth={"600px"} minWidth={"350px"}>
                    <Box className="close-pop-wrap">
                        <Box className="Heading">
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: "bold", color: "#fff", letterSpacing: "1px" }}
                            >
                                Members Only
                            </Typography>
                        </Box>
                        <CloseIcon onClick={() => setOpenConfirmModal(false)} className="CloseImg" />
                    </Box>
                    <Box className="ContentWrapper">
                        <Typography sx={{ fontWeight: 'bold', fontSize: '1rem', mb: 1 }}>
                            {clickedItemType === 'course' ? 'Join to access this course' : 'Join to access all recipes'}.
                        </Typography>
                        <Box display="flex" justifyContent="center" mt={3}>
                            <Button
                                onClick={() => {
                                    setOpenConfirmModal(false);
                                    navigate('/plans');
                                }}
                                variant="contained"
                                sx={{
                                    background: '#E29C2E',
                                    '&:hover': {
                                        background: '#C07D1A'
                                    }
                                }}
                            >
                                Subscribe Now
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

        </>
    );
};

const actionCreators = { fetchPaymentHistoryList };
export default connect(
    ({ user }) => ({
        user,
    }),
    actionCreators
)(Courses);

export const textClampStyles = (lines) => ({
    display: "-webkit-box",
    WebkitLineClamp: lines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    wordBreak: "break-word",
    textAlign: "justify",
    textTransform: 'capitalize'
});


const modalStyle = {
    overflow: "hidden",
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "90vh",
    backgroundColor: "white",
    boxShadow: 24,
    pb: 2,
    borderRadius: "8px",
    ".close-pop-wrap": {
        top: "0px",
        right: "0px",
        position: "sticky",
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#112225",
        img: {
            width: "24px",
            height: "24px",
        },
    },
    ".Heading": {
        display: "flex",
        alignItems: "center",
        h2: {
            mb: 0,
            color: "#fff",
        },
        svg: {
            mr: 1,
            width: "20px",
            height: "20px",
        },
    },
    ".CloseImg": {
        opacity: 1,
        borderRadius: "50%",
        p: "2px",
        border: "1px solid #fff",
        fontSize: "0.7rem",
        path: {
            fill: "#fff",
        },
    },
    ".ContentWrapper": {
        p: 2,
    },
};

